module.exports = __webpack_public_path__ + "static/media/day07_sticky.e064fd71.gif";